{
    "warning": "ATTENTION !",
    "message": "Ne saisissez pas ou ne collez pas de code que vous ne comprenez pas.\nL'utilisation de cette console risque de permettre aux hackers de se faire passer pour vous et de voler vos informations au moyen d'une attaque appelée Self-XSS."
}
